import React, {Component} from 'react';

// Components
import Login from '../../pages/login';
import {AuthProvider} from '../../authContext';
import { useLocation } from 'react-router';

class Auth extends Component {
  state = {};

  render() {
    const hasAuth = () => {
      const pathname = window.location.pathname
      if(pathname.includes("/r2")) {
        localStorage.setItem('logintype','r2')
        return true
      }
      return localStorage.getItem('token') !== null
    };
    const authProviderValue = {
      user: {
        role: localStorage.getItem('role') || '',
        name: localStorage.getItem('name') || '',
        warehouseId: localStorage.getItem('warehouseId') || '',
        partnerId: localStorage.getItem('partnerId') || '',
        sellerIds: localStorage.getItem('sellerIds') || '',
      },
    };
    return hasAuth() ? (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    ) : (
      <Login />
    );
  }
}

export default Auth;
